import { render, staticRenderFns } from "./ChannelStatusPostaCell.vue?vue&type=template&id=8e24253e&scoped=true"
import script from "./ChannelStatusPostaCell.vue?vue&type=script&lang=js"
export * from "./ChannelStatusPostaCell.vue?vue&type=script&lang=js"
import style0 from "./ChannelStatusPostaCell.vue?vue&type=style&index=0&id=8e24253e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e24253e",
  null
  
)

export default component.exports